<template>
  <div class="category-wrapper">
    <div v-if="editable" class="dropdown-wrapper">
      <Dropdown :options="actions" iconColor="black" />
    </div>
    <div class="cat-title handle">
      <span>
        <b-icon-justify />
      </span>
      {{category.title}}({{category.items.length}})
    </div>
    <div v-if="category.description" class="cat-description">{{category.description}}</div>
    <div
      class="no-data"
      v-if="items.length===0"
    >There are no items in this category yet. Click below to add item</div>

    <div v-else class="cat-items">
      <template v-for="(item) in items">
        <ItemCard :key="item.id" :index="item.id" :item="item" :editable="false" />
      </template>
    </div>
    <div class="cat-bottom">
      <b-button @click="openCategory" variant="link">View All</b-button>
      <b-button @click="openCategory" variant="info">Add Item</b-button>
    </div>
    <validation-observer v-slot="{invalid}">
      <b-modal
        :ok-disabled="invalid"
        @ok="editCategory"
        :id="category.id"
        size="sm"
        title="Edit Category"
      >
        <TextInput
          :rules="`required|CategoryName`"
          placeholder="Enter Category"
          v-model="categoryEdit.edit"
        />
        <TextInput placeholder="Enter Description" v-model="categoryEdit.description" />
      </b-modal>
    </validation-observer>
  </div>
</template>

<script>
import ItemCard from "../../pages/components/ItemCard";
import Dropdown from "../components/Dropdown";
import TextInput from "./Inputs/TextInput";
import { BIconJustify } from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
export default {
  props: {
    category: Object,
    index:  String,
    menuId: String,
    categories: Array,
    editable:{
      type:Boolean,
      default:true
    }
  },
  components: {
    TextInput,
    ItemCard,
    Dropdown,
    ValidationObserver,
    BIconJustify
  },
  data() {
    return {
      form: {},
      categoryEdit: {},
      file: [],
      formValues: "",
      fileLoading: false,
      actions: [
        {
          name: "Edit",
          icon: "Edit.svg",
          handler: this.onEdit,
          shouldRender: true,
          type: "Edit"
        },
        {
          name: `Delete`,
          icon: "delete.svg",
          handler: this.deleteCategory,
          shouldRender: true,
          type: "Delete"
        }
      ]
    };
  },
  methods: {
    fileChange(file) {
      const formData = new FormData();
      formData.append("csvUpload", file);
      const formValues = formData;
      this.file = file;
    },
    deleteFile(index, item) {
      const tempFiles = [...this.file];
      tempFiles.splice(index, 1);
      this.file = [...tempFiles];
    },

    addItem(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$store
        .dispatch("Menu/createItem", {
          file: this.file,
          menuId: this.menuId,
          category: this.category.name,
          form: this.form
        })
        .then(() => {
          this.$bvModal.hide(this.category.title + this.index);
        });
    },
    openCategory() {
      this.$store.commit("Category/SET_CURRENT_CATEGORY", this.category);
      this.$router.push({
        name: "CategoriesItems",
        params: {
          id: this.category.id
        }
      });
    },

    onEdit() {
      this.$bvModal.show(this.category.id);
    },
    deleteCategory() {
      this.$store
        .dispatch("Category/deleteCategory", {
          categoryId:this.category.id,
        })
        .then(() => {});
    },

    editCategory() {

      this.$store.dispatch("Category/editCategory", {
        categoryId:this.category.id,
        form:this.categoryEdit
      }).then(response=>{
        this.$bvModal.hide(this.category.id)
      })
    },

    getItems() {
      this.$store.dispatch("Category/fetchCategoryItems", {
        categoryName: this.category.name,
        items: this.category.items,
        load: true
      });
    }
  },
  computed: {
    progress() {
      return this.$store.state.Menu.uploadValue;
    },
    items() {
      return this.$store.state.Category[this.category.name];
    }
  },
  watch: {
    "category.items": {
      handler(items) {
        if (items.length > 0) {
          this.getItems();
        }
      },
      immediate: true,
      deep: true
    },
   
  },
  mounted() {
    this.categoryEdit = {
      edit: this.category.title,
      description: this.category.description
    };
  },
  created() {
    this.$store.commit("Category/SET_CATEGORY_NAME", this.category.name);
  },
  beforeDestroy() {
    this.$store.commit("Category/SET_CATEGORY_ITEMS", {
      categoryName: this.category.name,
      data: []
    });
  }
};
</script>

<style>
.category-wrapper {
  padding: 20px;
  -webkit-box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.02),
    0px 4px 6px rgba(0, 0, 0, 0.06);
  -moz-box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.02),
    0px 4px 6px rgba(0, 0, 0, 0.06);
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.02), 0px 4px 6px rgba(0, 0, 0, 0.06);
  border-radius: 5px;
  height: max-content;
  margin-bottom: 24px;
  background: white;
  position: relative;
}
.category-wrapper .no-data {
  display: flex;
  height: 57.6px;
  justify-content: center;
  align-items: center;
}
.category-wrapper .cat-title {
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
}

.cat-items {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 340px));
  grid-gap: 10px;
}

.category-wrapper .cat-bottom {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}

.dropdown-wrapper {
  color: black;
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 3;
}
</style>